import React, { Component } from 'react'
import OutsideClick from 'components/UI/OutsideClick'
import { Menu, StyledDropdown } from './styles'

class DropMenu extends Component {

  constructor(props) {
    super(props)

    this.state = {
      isOpen: false
    }
  }

  toggleOpen = () => this.setState(state => ({ isOpen: !state.isOpen }))

  onClose = () => this.setState({ isOpen: false })

  render() {
    const { children, target } = this.props
    const { isOpen } = this.state

    return (
      <StyledDropdown>
        <OutsideClick onOutsideClick={this.onClose}>
          <div onClick={this.toggleOpen}>
            {target}
          </div>
          {isOpen ? <Menu onClick={this.onClose}>{children}</Menu> : null}
        </OutsideClick>
      </StyledDropdown>
    )
  }
}

export default DropMenu
